import { Diagnostic, Rule } from "@siteimprove/alfa-act";
import { Element } from "@siteimprove/alfa-dom";
import { Language } from "@siteimprove/alfa-iana";
import { Iterable } from "@siteimprove/alfa-iterable";
import { Predicate } from "@siteimprove/alfa-predicate";
import { Err, Ok } from "@siteimprove/alfa-result";
import { Criterion } from "@siteimprove/alfa-wcag";
import { expectation } from "../common/act/expectation.js";
import { Scope, Stability } from "../tags/index.js";
const { hasAttribute, isDocumentElement } = Element;
const { isEmpty } = Iterable;
const { and, not, tee, test } = Predicate;
/**
 * @deprecated
 * This rule has been deprecated because `xml:lang` attribute are not used
 * anymore.
 */
export default Rule.Atomic.of({
    uri: "https://alfa.siteimprove.com/rules/sia-r6",
    requirements: [Criterion.of("3.1.1")],
    tags: [Scope.Page, Stability.Deprecated],
    evaluate({ document }) {
        // These will be set at most once since the rule only applies to the document element
        let cachedLang;
        let cachedXmlLang;
        return {
            applicability() {
                return document
                    .children()
                    .filter(isDocumentElement)
                    .filter((element) => test(and(hasAttribute("lang", (value) => Language.parse(value)
                    .tee((lang) => {
                    cachedLang = lang;
                })
                    .isOk()), hasAttribute("xml:lang", tee(not(isEmpty), (xmlLang) => {
                    cachedXmlLang = xmlLang;
                }))), element));
            },
            expectations(target) {
                // `cachedLang` and `cachedXmlLang` are set by the applicability
                return {
                    1: expectation(Language.parse(cachedXmlLang).every((xmlLang) => xmlLang.primary.equals(cachedLang.primary)), () => Outcomes.HasMatchingLanguages, () => Outcomes.HasNonMatchingLanguages),
                };
            },
        };
    },
});
/**
 * @public
 */
export var Outcomes;
(function (Outcomes) {
    Outcomes.HasMatchingLanguages = Ok.of(Diagnostic.of(`The \`lang\` and \`xml:lang\` attributes have matching primary language subtags`));
    Outcomes.HasNonMatchingLanguages = Err.of(Diagnostic.of(`The \`lang\` and \`xml:lang\` attributes do not have matching primary language subtags`));
})(Outcomes || (Outcomes = {}));
//# sourceMappingURL=rule.js.map